import { useDispatch, useSelector } from "react-redux";
import {
  actions as loginActions,
  asyncActions as loginAsyncActions,
} from "../../../../store/slices/loginSlice.js";

import { useEffect } from "react";
import BaseButton from "../../../../baseComponents/baseButton";

const EmailVerificationFragment = ({ checkCurrentVerificationStatus }) => {
  ///////////////////////////////////////////////////////////////dispatcher
  const dispatch = useDispatch();

  ///////////////////////////////////////////////////////////////reudx state
  const loginState = useSelector((state) => state.loginState);

  //////////////////////////////////////////////////////methods
  const sendMailVerificationTokenAgain = async () => {
    dispatch(loginAsyncActions.sendMailVerificationAgain());
  };

  const canAskForMailVerificationTokenAgain = (showLoading) => {
    if (loginState.login.userInfo.canAskForMailVerificationAgain === false) {
      const resPromise = dispatch(
        loginAsyncActions.canAskForMailVerificationTokenAgain(showLoading)
      );
      return resPromise;
    }
  };

  //////////////////////////////////////////////////////effects

  useEffect(() => {

    let intervalCounter = 0;
   
    let resPromise;
    let resPromiseInterval;
   
    let canAskAgainPromise;
    let canAskAgainPromiseFromInterval;

    canAskAgainPromise = canAskForMailVerificationTokenAgain(true);

    resPromise = checkCurrentVerificationStatus();


    const interval = setInterval(() => {
      intervalCounter++;
      if (intervalCounter > 60) {
        clearInterval(interval);
      }
      resPromiseInterval = checkCurrentVerificationStatus();
      canAskAgainPromiseFromInterval =
        canAskForMailVerificationTokenAgain(false);
    }, 3000);

    return () => {
      if (canAskAgainPromise) {
        canAskAgainPromise.abort();
      }

      if (canAskAgainPromiseFromInterval) {
        canAskAgainPromiseFromInterval.abort();
      }

      if (resPromise) {
        resPromise.abort();
      }

      if (resPromiseInterval) {
        resPromiseInterval.abort();
      }
      
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      {loginState.login.userInfo.canAskForMailVerificationAgain && (
        <BaseButton onClick={sendMailVerificationTokenAgain}>
          askForEmailTokenAgain
        </BaseButton>
      )}
    </>
  );
};

export default EmailVerificationFragment;
